'use client'

import React from 'react'
import { Snackbar, Alert } from '@mui/material'
import { useNotification } from '@/hooks'

const AppNotification: React.FC = () => {
  const { notification, closeNotification } = useNotification()
  const { isVisible, duration, type, message } = notification

  return (
    <Snackbar
      disableWindowBlurListener
      open={isVisible}
      autoHideDuration={duration}
      ClickAwayListenerProps={{
        onClickAway: () => ({}),
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={closeNotification}
    >
      <Alert variant="filled" severity={type} onClose={closeNotification}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default AppNotification
